import React from "react";
import styled, { keyframes } from "styled-components";
import { ColorTokens, useColorTokens } from "@tvg/design-system";

const pulseAnimation = (colorTokens: ColorTokens) => keyframes`
  0% {
    fill: ${colorTokens.content.loadingDefault};
  }
  
  50% {
    fill: ${colorTokens.border.default};
  }
  
  100% {
    fill: ${colorTokens.content.loadingDefault};
  }
`;

const SVG = styled.svg`
  display: block;
  width: 100%;
  height: 57px;
  rect.pulse {
    animation: ${({ theme }) => pulseAnimation(theme)} 1.25s infinite;
  }
`;

export const IppMatchConditionsMask = () => {
  const colorTokens = useColorTokens();
  return (
    <div data-qa-label="ippMatchConditionsMask">
      <SVG theme={colorTokens}>
        <rect width="100%" height="57" fill="#fff" rx=".5" />
        <rect
          className="pulse"
          width="226"
          height="12"
          x="12"
          y="15"
          fill={colorTokens.content.loadingDefault}
          rx="1"
        />
        <rect
          className="pulse"
          width="179"
          height="9"
          x="12"
          y="35"
          fill={colorTokens.content.loadingDefault}
          rx="1"
        />
      </SVG>
    </div>
  );
};
